import React, { useState, useEffect, useRef } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw, ContentState, Modifier } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { TextField, Chip, Box, Typography } from '@material-ui/core'

const MERGE_FIELDS = ['firstName', 'companyName']

/**
 * WYSIWYG body editor over a fixed letterhead. Emits HTML (draftToHtml) up to the
 * parent — never raw Draft.js ContentState, which the email service rejects.
 */
export default function TemplateEditor ({ subject, bodyHtml, onChange }) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const initialized = useRef(false)

  // Seed the editor once from incoming HTML (e.g. loading an existing template).
  useEffect(() => {
    if (initialized.current) return
    initialized.current = true
    if (bodyHtml) {
      const blocks = htmlToDraft(bodyHtml)
      if (blocks) {
        const content = ContentState.createFromBlockArray(blocks.contentBlocks)
        setEditorState(EditorState.createWithContent(content))
      }
    }
  }, [bodyHtml])

  const handleEditorChange = (state) => {
    setEditorState(state)
    const html = draftToHtml(convertToRaw(state.getCurrentContent()))
    onChange({ subject, bodyHtml: html })
  }

  const insertMergeField = (field) => {
    const token = `{{${field}}}`
    const content = editorState.getCurrentContent()
    const selection = editorState.getSelection()
    const next = Modifier.insertText(content, selection, token)
    const newState = EditorState.push(editorState, next, 'insert-characters')
    handleEditorChange(newState)
  }

  return (
    <Box>
      <TextField
        label="Subject"
        fullWidth
        variant="outlined"
        size="small"
        value={subject || ''}
        onChange={(e) => onChange({ subject: e.target.value, bodyHtml })}
        style={{ marginBottom: 16 }}
        helperText="Merge fields like {{companyName}} work in the subject too."
      />

      <Box style={{ marginBottom: 8 }}>
        <Typography variant="caption" color="textSecondary">Insert merge field:&nbsp;</Typography>
        {MERGE_FIELDS.map(f => (
          <Chip
            key={f}
            label={`{{${f}}}`}
            size="small"
            onClick={() => insertMergeField(f)}
            style={{ marginRight: 6, cursor: 'pointer' }}
          />
        ))}
      </Box>

      <div style={{ border: '1px solid #ccc', borderRadius: 4, padding: 8, minHeight: 280 }}>
        <Editor
          editorState={editorState}
          wrapperClassName="campaign-editor-wrapper"
          editorClassName="campaign-editor"
          onEditorStateChange={handleEditorChange}
          toolbar={{
            options: ['inline', 'blockType', 'list', 'textAlign', 'link', 'history']
          }}
        />
      </div>
    </Box>
  )
}
